import { createSlice } from '@reduxjs/toolkit'
import { initialTeamState } from '../initialState/team'
import {
  fetchTeamsByRoomId,
  createNewTeam,
  updateExistingTeam,
  deleteExistingTeam,
  bulkAssignPlayersToTeamsThunk,
} from '../asyncThunks/team'

const teamSlice = createSlice({
  name: 'team',
  initialState: initialTeamState,
  reducers: {
    clearTeams: (state) => {
      state.teams = []
      state.error = null
    },
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamsByRoomId.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchTeamsByRoomId.fulfilled, (state, action) => {
        state.isLoading = false
        state.teams = action.payload
        state.error = null
      })
      .addCase(fetchTeamsByRoomId.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
      // Create team
      .addCase(createNewTeam.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(createNewTeam.fulfilled, (state, action) => {
        state.isLoading = false
        state.teams.push(action.payload)
        state.error = null
      })
      .addCase(createNewTeam.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
      // Update team
      .addCase(updateExistingTeam.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(updateExistingTeam.fulfilled, (state, action) => {
        state.isLoading = false
        const index = state.teams.findIndex(
          (team) => team.id === action.payload.id
        )
        if (index !== -1) {
          state.teams[index] = action.payload
        }
        state.error = null
      })
      .addCase(updateExistingTeam.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
      // Delete team
      .addCase(deleteExistingTeam.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(deleteExistingTeam.fulfilled, (state, action) => {
        state.isLoading = false
        state.teams = state.teams.filter((team) => team.id !== action.payload)
        state.error = null
      })
      .addCase(deleteExistingTeam.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
      .addCase(bulkAssignPlayersToTeamsThunk.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(bulkAssignPlayersToTeamsThunk.fulfilled, (state) => {
        state.isLoading = false
        state.error = null
      })
      .addCase(bulkAssignPlayersToTeamsThunk.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
  },
})

export const { clearTeams, clearError } = teamSlice.actions
export default teamSlice.reducer
